import { render, staticRenderFns } from "./showSurvey.vue?vue&type=template&id=b33712a6&scoped=true&"
import script from "./showSurvey.vue?vue&type=script&lang=js&"
export * from "./showSurvey.vue?vue&type=script&lang=js&"
import style0 from "./showSurvey.vue?vue&type=style&index=0&id=b33712a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33712a6",
  null
  
)

export default component.exports